"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributorEditForm = void 0;
const core_1 = require("@material-ui/core");
const button_1 = require("client/components/material/button");
const text_field_1 = require("client/components/material/text-field");
const callable_1 = require("client/components/ui/callable");
const form_1 = require("client/components/ui/form");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const shipping_options_1 = require("../distributor-list/components/shipping-options");
require("./distributor-edit-form.less");
const styles = core_1.createStyles({
    header: {
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "1rem"
    },
    content: {
        "display": "grid",
        "gridGap": "1rem",
        "gridTemplateColumns": "repeat(2, 1fr)",
        "@media only screen and (max-width: 1200px)": {
            gridTemplateColumns: "repeat(1, 1fr)"
        }
    }
});
const decorate = core_1.withStyles(styles);
let DistributorEditFormUnstyled = class DistributorEditFormUnstyled extends React.Component {
    constructor(props) {
        super(props);
        this.distributor = {
            distributor: "",
            contactEmail: "",
            contactEmailTwo: "",
            contactEmailThree: ""
        };
        this.status = form_1.FormStatus.Clean;
        this.errorMessage = "";
        this.renderFormContent = () => (React.createElement("div", { className: "distributor-edit-form" },
            React.createElement("div", { className: this.props.classes.header },
                React.createElement(core_1.Typography, { variant: "title" }, "Edit distributor"),
                !this.props.isDisabled && React.createElement(button_1.MaterialButton, { color: "secondary", onClick: this.handleViewInv }, this.props.distributor
                    ? `view ${this.props.distributor.distributor} inv`
                    : "view inv")),
            React.createElement("div", { className: this.props.classes.content },
                React.createElement("div", null,
                    React.createElement(core_1.Typography, { variant: "title", gutterBottom: true }, "Distributor Info"),
                    React.createElement("div", null,
                        React.createElement(text_field_1.MaterialTextField, { autoFocus: true, label: "Distributor name", onChange: this.handleDistributorChange("distributor"), type: "text", required: true, value: this.distributor.distributor, disabled: this.props.isDisabled }),
                        React.createElement(text_field_1.MaterialTextField, { autoFocus: true, label: "Contact email", required: true, onChange: this.handleDistributorChange("contactEmail"), type: "text", value: this.distributor.contactEmail, disabled: this.props.isDisabled }),
                        React.createElement(text_field_1.MaterialTextField, { autoFocus: true, label: "Contact Email 2", onChange: this.handleDistributorChange("contactEmailTwo"), type: "text", value: this.distributor.contactEmailTwo, disabled: this.props.isDisabled }),
                        React.createElement(text_field_1.MaterialTextField, { autoFocus: true, label: "Contact Email 3", onChange: this.handleDistributorChange("contactEmailThree"), type: "text", value: this.distributor.contactEmailThree, disabled: this.props.isDisabled }))),
                !this.props.isDisabled && React.createElement(shipping_options_1.ShippingOptions, { distributor: this.props.distributor }))));
        this.handleDistributorChange = (field) => (event) => {
            this.distributor[field] = event.target.value;
        };
        this.handleSubmit = async () => {
            // Update the distributor to save
            const updatedDistributor = Object.assign(Object.assign({}, this.props.distributor), this.distributor);
            try {
                callable_1.callable(this.props.onSave)(updatedDistributor);
            }
            catch (e) {
                throw new Error(e);
            }
        };
        this.handleCancel = () => {
            try {
                callable_1.callable(this.props.onCancel)();
            }
            catch (e) {
                throw new Error(e);
            }
        };
        this.handleDelete = () => {
            try {
                callable_1.callable(this.props.onDelete)();
            }
            catch (e) {
                throw new Error(e);
            }
        };
        this.handleViewInv = () => {
            try {
                callable_1.callable(this.props.onViewInv)();
            }
            catch (e) {
                throw new Error(e);
            }
        };
        if (this.props && this.props.distributor) {
            this.distributor.distributor = this.props.distributor.distributor;
            this.distributor.contactEmail = this.props.distributor.contactEmail;
            const splitEmails = this.props.distributor.contactEmail.split(";");
            if (splitEmails.length === 2) {
                this.distributor.contactEmail = splitEmails[0];
                this.distributor.contactEmailTwo = splitEmails[1];
            }
            if (splitEmails.length === 3) {
                this.distributor.contactEmail = splitEmails[0];
                this.distributor.contactEmailTwo = splitEmails[1];
                this.distributor.contactEmailThree = splitEmails[2];
            }
        }
    }
    render() {
        return (React.createElement(form_1.UiForm, { buttons: [
                React.createElement(button_1.MaterialButton, { className: "btnDelete", onClick: this.handleDelete }, this.props.isDisabled ? "Reactivate" : "Disable"),
                React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.handleCancel }, "Cancel"),
                "Save"
            ], loading: false, isChanged: () => true, status: this.status, saved: "Saved", onSubmit: this.handleSubmit, error: this.errorMessage, shouldDisableSave: this.props.isDisabled }, this.renderFormContent()));
    }
};
__decorate([
    mobx_1.observable
], DistributorEditFormUnstyled.prototype, "distributor", void 0);
__decorate([
    mobx_1.observable
], DistributorEditFormUnstyled.prototype, "status", void 0);
__decorate([
    mobx_1.observable
], DistributorEditFormUnstyled.prototype, "errorMessage", void 0);
__decorate([
    mobx_1.action
], DistributorEditFormUnstyled.prototype, "handleDistributorChange", void 0);
__decorate([
    mobx_1.action
], DistributorEditFormUnstyled.prototype, "handleSubmit", void 0);
__decorate([
    mobx_1.action
], DistributorEditFormUnstyled.prototype, "handleCancel", void 0);
__decorate([
    mobx_1.action
], DistributorEditFormUnstyled.prototype, "handleDelete", void 0);
__decorate([
    mobx_1.action
], DistributorEditFormUnstyled.prototype, "handleViewInv", void 0);
DistributorEditFormUnstyled = __decorate([
    mobx_react_1.observer
], DistributorEditFormUnstyled);
exports.DistributorEditForm = decorate(DistributorEditFormUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/tabs/distributors/components/distributor-edit-form/distributor-edit-form.tsx
// module id = 3519
// module chunks = 0